<app-form *ngIf="displayQuestions" [questions]="questions"></app-form>
